// extracted by mini-css-extract-plugin
export default {"imageWrapper":"kF-z","hovered":"lF-z","hoverImage":"mF-z","mainImage":"nF-z","imageNoBackground":"oF-z","fullSizeImage":"pF-z"};